import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import UserDetails from './UserDetails/UserDetails';
import UserRights from './UserRights/UserRights';
import { useTranslation } from 'react-i18next';

const UserConfig: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const {t} = useTranslation('user_config');

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="fullWidth"
        aria-label="user config tabs"
        TabIndicatorProps={{
          sx: {
            backgroundColor: '#E25E3E',
            height: 3,
            borderRadius: 2,
          },
        }}
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '16px',
            width: '50%',
            minWidth: '50%',
            maxWidth: '50%',
          },
          '& .Mui-selected': {
            color: '#000',
          },
        }}
      >
        <Tab label={t('User_Details')} />
        <Tab label={t('User_Rights')} />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        {tabIndex === 0 && <UserDetails />}
        {tabIndex === 1 && <UserRights />}
      </Box>
    </Box>
  );
};

export default UserConfig;
